import Store from '../../../../../GlobalState/Store';

export const navigatePostLogin = ({ locationHistory }) => {
    const { play } = Store.getState();
    const destination = play.isPvpGameMode
      ? '/inventory'
      : 'leaderboard';
    locationHistory.push(destination);
};
